import { defineStore } from 'pinia'
import actionsAdMetrics from './actionsAdMetrics'
import actionsCampaignMetrics from './actionsCampaignMetrics'
import actionsLeadMetrics from './actionsLeadMetrics'
import actionsFiles from './actionsFiles'

export const useReportsStore = defineStore('reports', {
  state: () => {
    return {
      partnerCategories: [],
      partnerCampaignCategories: [],
      vendor: null,
      leadMetricReport: [],
      leadMetricsTotals: [],
      selectedLeadMetric: { label: 'Total Leads', value: 'leads_count'},
      campaignReport: [],
      partnerReport: [],
      allReport: [],
      reportTotals: {},
      showCSVLoadingIndicator: false,
      showAdMetricsLoadingIndicator: false,
      showLeadMetricsLoadingIndicator: false,
      showAdMetricsChartDataLoadingIndicator: true,
      adMetricsChartData: null,
      selectedMetric: { label: 'Total Clicks', value: 'clicks' },
      partnerMetricData: [],
      leadMetricsChartData: [],
    }
  },
  actions: {
    ...actionsAdMetrics,
    ...actionsCampaignMetrics,
    ...actionsLeadMetrics,
    ...actionsFiles,
  },
})
